exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.locker_code_no[data-v-a0befe50] {\n    height: auto;\n    width: 100%;\n    max-width: 600px;\n    margin: 10px auto 20px;\n}\n", ""]);

// exports
